var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPellet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5997_133531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5997_133531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7497 29.3333C13.7719 29.3333 11.2497 28.3 9.18301 26.2333C7.11634 24.1667 6.08301 21.6445 6.08301 18.6667C6.08301 16.1556 6.82745 13.7445 8.31634 11.4333C9.80523 9.12223 11.8497 7.10001 14.4497 5.36667C14.9386 5.03334 15.4441 5.01667 15.9663 5.31667C16.4886 5.61667 16.7497 6.06667 16.7497 6.66667V8.40001C16.7497 9.15556 17.0108 9.7889 17.533 10.3C18.0552 10.8111 18.6941 11.0667 19.4497 11.0667C19.8275 11.0667 20.1886 10.9833 20.533 10.8167C20.8775 10.65 21.183 10.4111 21.4497 10.1C21.6275 9.87779 21.8552 9.7389 22.133 9.68334C22.4108 9.62779 22.6719 9.6889 22.9163 9.86667C24.3163 10.8667 25.4163 12.1445 26.2163 13.7C27.0163 15.2556 27.4163 16.9111 27.4163 18.6667C27.4163 21.6445 26.383 24.1667 24.3163 26.2333C22.2497 28.3 19.7275 29.3333 16.7497 29.3333ZM8.74967 18.6667C8.74967 19.8222 8.98301 20.9167 9.44967 21.95C9.91634 22.9833 10.583 23.8889 11.4497 24.6667C11.4275 24.5556 11.4163 24.4556 11.4163 24.3667V24.0667C11.4163 23.3556 11.5497 22.6889 11.8163 22.0667C12.083 21.4445 12.4719 20.8778 12.983 20.3667L16.7497 16.6667L20.5163 20.3667C21.0275 20.8778 21.4163 21.4445 21.683 22.0667C21.9497 22.6889 22.083 23.3556 22.083 24.0667V24.3667C22.083 24.4556 22.0719 24.5556 22.0497 24.6667C22.9163 23.8889 23.583 22.9833 24.0497 21.95C24.5163 20.9167 24.7497 19.8222 24.7497 18.6667C24.7497 17.5556 24.5441 16.5056 24.133 15.5167C23.7219 14.5278 23.1275 13.6445 22.3497 12.8667C21.9052 13.1556 21.4386 13.3722 20.9497 13.5167C20.4608 13.6611 19.9608 13.7333 19.4497 13.7333C18.0719 13.7333 16.8775 13.2778 15.8663 12.3667C14.8552 11.4556 14.2719 10.3333 14.1163 9.00001C12.383 10.4667 11.0552 12.0278 10.133 13.6833C9.21079 15.3389 8.74967 17 8.74967 18.6667ZM16.7497 20.4L14.8497 22.2667C14.6052 22.5111 14.4163 22.7889 14.283 23.1C14.1497 23.4111 14.083 23.7333 14.083 24.0667C14.083 24.7778 14.3441 25.3889 14.8663 25.9C15.3886 26.4111 16.0163 26.6667 16.7497 26.6667C17.483 26.6667 18.1108 26.4111 18.633 25.9C19.1552 25.3889 19.4163 24.7778 19.4163 24.0667C19.4163 23.7111 19.3497 23.3833 19.2163 23.0833C19.083 22.7833 18.8941 22.5111 18.6497 22.2667L16.7497 20.4Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPellet);
export default __webpack_public_path__ + "static/media/pellet.a92939631af3893474ac145d16ab12ad.svg";
export { ForwardRef as ReactComponent };